import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { Five9FormItemKeys } from "../constants";

import sharedStyles from "../SharedDemoStyles.module.scss";

const REQUIRED_NAME_RULE = generateFormItemRequiredRules("Five9 selection");
const REQUIRED_ID_RULE = generateFormItemRequiredRules("Campaign Id");
const NAME_LABEL = "Campaign Name";
const ID_LABEL = "Five9 Campaign";
const ID_PLACEHOLDER = "Five9 Campaign Id";

export function Five9FormItems(): JSX.Element {
    return (
        <>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                showFormLabel
                name={Five9FormItemKeys.five9Name}
                label={NAME_LABEL}
                rules={REQUIRED_NAME_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                name={Five9FormItemKeys.five9ID}
                label={ID_LABEL}
                placeholder={ID_PLACEHOLDER}
                showFormLabel
                rules={REQUIRED_ID_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
        </>
    );
}
